
export default {

    projectMeasuresToDelete: {},
    scenarioRooms: {},

    projectMeasures: [],
    togglingSelectionForMeasure: null,
}
